import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { useLoginRegistrationRegistrationGtmPushFullStoryTracking } from '../../hooks/useLoginRegistrationRegistrationGtmPushFullStoryTracking'
import { useGetRedirectToTargetPageAfterRegistration } from '../../useGetRedirectToTargetPageAfterLogin'
import { LoginRegistrationRegistrationForm } from '../LoginRegistrationRegistrationForm/LoginRegistrationRegistrationForm'

interface RegistrationModelInterface {
  isOpen: boolean
  onClose: () => void
}

export const LoginRegistrationRegistrationModal: FC<
  RegistrationModelInterface
> = ({ isOpen, onClose }) => {
  const redirectToTargetPage = useGetRedirectToTargetPageAfterRegistration()
  useLoginRegistrationRegistrationGtmPushFullStoryTracking(isOpen)

  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
      slotProps={{
        dialog: {
          className: 'tablet:max-h-[90vh] tablet:max-w-[630px]',
        },
      }}
    >
      <DialogTitle className="bg-light-primary-low" onClose={onClose}>
        <FormattedMessage id="registration.createAccount.headline" />
      </DialogTitle>
      <DialogContent>
        <LoginRegistrationRegistrationForm
          afterLoggedIn={redirectToTargetPage}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  )
}
